export const errorDJRestToString = (errors) => {
    if (!errors){
        return null
    }
    return errors.join(', ')
};
